<template>
    <div class="container mt-xs-7 mt-sm-3 mt-md-2 mt-lg-1 mt-xl-1" style="padding: 2% 10%">
      <t-theme-essay :themeId="$route.params.id"></t-theme-essay>
      <div class="columns mt-2">
        <TTab :tabs="tabs">
          <div id="anexar" class="tabcontent" style="display:block">
            <div class="is-mobile container">
              <send-image-essay
                titleButtonSearch="Buscar Imagem"
                titleButtonSend="Enviar para a correção"
              ></send-image-essay>
            </div>
          </div>
          <div id="redigir" class="tabcontent" v-if="notImplemented">
            <div class="is-mobile container">
              <send-text-essay></send-text-essay>
            </div>
          </div>
        </TTab>
      </div>
    </div>
</template>

<script>
import SendImageEssay from './SendImageEssay.vue'
import SendTextEssay from './SendTextEssay.vue'
import TThemeEssay from '@/components/TThemeEssay.vue'
import TTab from '@/components/TTab.vue'
import Notification from '@/support/mixins/notifications.mixin'

export default {
  name: 'HelloWorld',
  components: {
    SendImageEssay,
    SendTextEssay,
    TThemeEssay,
    TTab
  },
  mixins: [Notification],
  data () {
    return {
      notImplemented: false,
      tabs: [
        {
          name: 'ANEXAR',
          class: 'tablinks active',
          id: 'anexar',
          icon: 'fa-paperclip '
        }
        // {
        //   name: 'REDIGIR',
        //   class: 'tablinks',
        //   id: 'redigir',
        //   icon: 'fa-edit'
        // }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
